import commaNumber from "comma-number";

export const formatDollars = (amount: number | undefined) => {
  if (amount === undefined) {
    return "";
  }

  const isNegative = amount < 0;
  if (isNegative) {
    amount = Math.abs(amount);
  }

  let formattedAmount = "$" + commaNumber((amount || 0).toFixed(2));
  if (isNegative) {
    formattedAmount = `-${formattedAmount}`;
  }

  return formattedAmount;
};

export const formatShorthandDollars = (amount: number): string => {
  if (amount < 1000) {
    return `$${amount.toFixed(0)}`;
  } else if (amount < 1000000) {
    const thousands = amount / 1000;
    if (thousands < 10) {
      return `$${thousands.toFixed(1)}K`;
    } else {
      return `$${Math.round(thousands)}K`;
    }
  } else {
    const millions = amount / 1000000;
    return `$${millions.toFixed(1)}M`;
  }
};
